'use client'

import { IProduct } from "@/lib/types/productType";
import { cn } from "@/lib/utils";
import { TrendingUp } from "lucide-react";
import { SectionTitle } from "../SectionTitle";
import { Button } from "../ui/Button";
import ProductCard from "./ProductCard";

interface IProductGrid {
  variant: 'white' | 'gray',
  title: string,
  products: IProduct[]
}

export function ProductGrid({ title, variant, products }: IProductGrid) {
  return (
    <section className={
      cn("py-16 px-6 dark:bg-gray-900",
        variant == 'white' ?
          'bg-white ' :
          'bg-gray-50 '
      )
    }>
      <div className="mx-auto">
        <div className="flex">
          <div className="flex flex-1/2">
            <SectionTitle title={title} />
          </div>
          <div className="flex flex-1/2 items-center justify-between mb-8">
            <SectionTitle title="" />
            <Button variant="outline">
              <TrendingUp className="mr-2 h-4 w-4" />
              View All
            </Button>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 3xl:xl:grid-cols-8 gap-4">
          {products.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </section>
  )
}
